/* global I18n */
import './styles.scss'

import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useActions, useMountedLogic, useValues } from 'kea'

import Button from 'lib/tags/button'
import ErrorIcon from 'lib/icons/error'
import AlertIcon from 'lib/icons/alert'
import FaceIcon from 'lib/icons/face'

import webcamLogic from './logic'
import webcamSaga from './saga'

const Webcam = ({ capture, close, withIconsUi }) => {
  useMountedLogic(webcamSaga)

  const {
    counterValue,
    error,
    inputHeight,
    inputWidth,
    isActionsActive,
    isCamReady,
    previewImage,
    stream,
    uiHeight,
    uiWidth
  } = useValues(webcamLogic)
  const { initUserMedia, initStream, adjustView, takePicture, startWebcam, uploadPicture } = useActions(webcamLogic)

  useEffect(() => {
    const video = document.getElementById('video-webcam')

    if (video) {
      video.addEventListener('canplay', initStream, false)
      window.addEventListener('resize', adjustView)
      initUserMedia()
    }

    return () => {
      if (stream) {
        const videoTracks = stream.getVideoTracks()
        if (videoTracks.length > 0) {
          videoTracks[0].stop()
        }
      }

      window.removeEventListener('canplay', initStream)
      window.removeEventListener('resize', adjustView)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleUploadPicture = () => {
    uploadPicture(capture)
  }
  return (
    <div className={`webcam-bloc${withIconsUi ? ' bloc-wrapper' : ''}`}>
      <div className='stream-bloc' style={{ width: uiWidth, height: uiHeight }}>
        {(!isCamReady || error) && (
          <div className='webcam-message' style={{ width: uiWidth, height: uiHeight }}>
            <div className='aligner-item'>
              {withIconsUi && (error ? <ErrorIcon /> : <AlertIcon />)}
              <div className={`${error ? 'error' : 'warning'}-message`}>
                {!error && <span className='connect-webcam'>{I18n.t('profiles.photos.webcam.prepare_webcam')}</span>}
                <span>{error || I18n.t('profiles.photos.webcam.permission_chrome')}</span>
              </div>
            </div>
          </div>
        )}
        <img
          className={previewImage ? 'show' : 'hide'}
          id='photo'
          style={{ left: (uiWidth - inputWidth) / 2, top: (uiHeight - inputHeight) / 2 }}
          src={previewImage}
          width={inputWidth}
          height={inputHeight}
          alt='preview'
        />
        <video
          style={{ left: (uiWidth - inputWidth) / 2, top: (uiHeight - inputHeight) / 2 }}
          width={inputWidth}
          height={inputHeight}
          id='video-webcam'
          autoPlay
        />

        <canvas className={previewImage ? 'show' : 'hide'} id='preview-canvas' />
        <canvas className='hide' id='original-image-canvas' />
        <canvas className='hide' id='upload-image-canvas' />
        {counterValue && (
          <div className='snap-counter' style={{ width: uiWidth, height: uiHeight, lineHeight: `${uiHeight}px` }}>
            {counterValue}
          </div>
        )}
        {withIconsUi && !counterValue && !previewImage ? (
          <div className='snap-counter' style={{ width: uiWidth, height: uiHeight, lineHeight: `${uiHeight}px` }}>
            <div className='cheese'>
              <FaceIcon />
              {I18n.t('profiles.photos.webcam.cheese')}
            </div>
          </div>
        ) : null}
        {error && <div className={`webcam-error ${error ? 'show' : 'hide'}`}>{error}</div>}
      </div>

      <div className='actions-bloc'>
        {!withIconsUi && (
          <Button
            color='white'
            backgroundColor='green'
            className='submit-btn'
            onClick={previewImage ? startWebcam : close}
            isSubmitting={false}
            disabled={false}
            isStyleDisabled={false}
            content={
              previewImage ? I18n.t('profiles.photos.webcam.restart') : I18n.t('bookings.edit_payment.gift_card_close')
            }
          />
        )}
        {previewImage && withIconsUi ? (
          <Button
            color='white'
            backgroundColor='green'
            className='submit-btn retry'
            onClick={previewImage ? startWebcam : close}
            isSubmitting={false}
            disabled={false}
            isStyleDisabled={false}
            content={I18n.t('profiles.photos.webcam.restart')}
          />
        ) : null}
        <Button
          color='white'
          backgroundColor='green'
          className='submit-btn'
          onClick={previewImage ? handleUploadPicture : takePicture}
          isSubmitting={false}
          disabled={!isActionsActive}
          isStyleDisabled={!isActionsActive}
          content={
            previewImage ? I18n.t('profiles.photos.webcam.upload') : I18n.t('profiles.photos.webcam.take_avatar_photo')
          }
        />
      </div>
    </div>
  )
}

Webcam.propTypes = {
  capture: PropTypes.func,
  close: PropTypes.func,
  withIconsUi: PropTypes.bool
}

export default Webcam
